/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_Netsuite_LegacyInputs */

const en_mapping_system_netsuite_legacy = /** @type {(inputs: Mapping_System_Netsuite_LegacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NetSuite (legacy)`)
};

/**
* | output |
* | --- |
* | "NetSuite (legacy)" |
*
* @param {Mapping_System_Netsuite_LegacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_netsuite_legacy = /** @type {((inputs?: Mapping_System_Netsuite_LegacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_Netsuite_LegacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_netsuite_legacy(inputs)
});